<template>
  <am-card class="am-accordion" :elevation="0" outlined @toggle="onToggle" ref="root">
    <!-- @slot Default to children items -->
    <slot />
  </am-card>
</template>

<script>
import { AmCard } from "../Card";

export default {
  components: {
    AmCard
  },
  props: {
    /**
     * Index of initial active item
     */
    initialActive: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      active: this.initialActive
    };
  },
  mounted() {
    this.$refs.root.$children.forEach((item, index) => {
      item.isOpen = index === this.active;
    });
  },
  methods: {
    onToggle: function(el) {
      this.$refs.root.$children.forEach(item => {
        item.isOpen = item.$el === el ? !item.isOpen : false;
      });
    }
  }
};
</script>
